module.exports = __webpack_public_path__ + "img/1487352419.bbece714.jpg";